/* eslint-disable no-console */

import axios from 'axios';
import log from '@/logger';
import store from '@/store';
import ls from '@/helpers/localStorage';
import { checkResponseForMaintenance, checkResponseForTaxInfo, checkResponseForApiGoingOffline, checkResponseForDocumentUpload } from './utils';

const ERROR_STATUS_CODES = [500, 501, 502, 503, 504];
const UNAUTHORIZED_STATUS_CODE = 401;

let refreshSubscribers = [];
let isRefreshing = false;

function tokenRefreshSubscribe(cb) {
  refreshSubscribers.push(cb);
}

function tokenRefreshComplete(token) {
  refreshSubscribers.map(cb => cb(token));
  refreshSubscribers = [];
}

export default (error) => {
  if (!error.response) {
    return Promise.reject(error);
  }
  const { config, response: { status } } = error;
  const originalRequest = config;

  // Skip token refresh for 2FA login endpoints - they use a different token mechanism
  const isTwoFactorLoginEndpoint = config.url && (
    config.url.includes('TwoFactor/SendCode') ||
    config.url.includes('TwoFactor/Verify')
  );

  if (status === UNAUTHORIZED_STATUS_CODE && !isTwoFactorLoginEndpoint) {
    log.info('[TOKEN] Unauthorized');
    if (!isRefreshing) {
      isRefreshing = true;
      const payload = {
        grant_type: 'refresh_token',
        refresh_token: ls.get('refreshToken'),
      };
      store.dispatch('user/login', payload)
        .then(() => {
          isRefreshing = false;
          log.info('[TOKEN] REFRESHED');
          tokenRefreshComplete(ls.get('token'));
        })
        .catch(() => {
          log.info('[TOKEN] CANNOT REFRESH');
          store.dispatch('user/setToken', null);
        });
    }

    return new Promise((resolve) => {
      tokenRefreshSubscribe((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        log.info('[TOKEN] Retry');
        resolve(axios(originalRequest));
      });
    });
  }

  if (error.response) {
    checkResponseForApiGoingOffline(error.response);
    checkResponseForMaintenance(error.response);
    checkResponseForTaxInfo(error.response);
    checkResponseForDocumentUpload(error.response);
    log.error('API - ERROR', error.response.status, error.response.config.url);
    if (ERROR_STATUS_CODES.indexOf(error.response.status) !== -1) {
      store.dispatch('app/setServerError', true);
    }
  } else if (error.request) {
    log.error('The request was made but no response was received');
  } else {
    log.error('Something happened in setting up the request that triggered an error');
  }

  return Promise.reject(error);
};



// WEBPACK FOOTER //
// ./src/services/interceptors/responseError.js